import React from 'react';
import SearchForm from '@react/Eligibility/SearchForm';
import { useHabitat } from '@react/shared/HabitatContext';
const EligibilitySearch = () => {
    const { title, subtitle } = useHabitat();
    return (React.createElement("div", { className: "ec-search site-wide-new" },
        React.createElement("div", { className: "ec-search__inner" },
            React.createElement("div", null,
                React.createElement("div", { className: "ec-search__title-block" },
                    React.createElement("h2", { className: "ec-search__title", dangerouslySetInnerHTML: { __html: title } }),
                    React.createElement("h3", { className: "ec-search__subtitle", dangerouslySetInnerHTML: { __html: subtitle } })),
                React.createElement(SearchForm, null)))));
};
export default EligibilitySearch;
